import React from 'react';

const selectClass = 'rounded-md border border-slate-700 bg-slate-950 px-2 py-1.5 text-xs text-slate-200';

const TenantFilterBar = ({ filters, setFilters }) => {
  const update = (key, value) => setFilters((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        className="rounded-md border border-slate-700 bg-slate-950 px-2 py-1.5 text-xs text-slate-200"
        placeholder="Cari tenant"
        value={filters.search || ''}
        onChange={(e) => update('search', e.target.value)}
      />

      <select className={selectClass} value={filters.plan || ''} onChange={(e) => update('plan', e.target.value)}>
        <option value="">Semua Paket</option>
        <option value="BASIC">BASIC</option>
        <option value="PRO">PRO</option>
        <option value="ENTERPRISE">ENTERPRISE</option>
      </select>

      <select className={selectClass} value={filters.status || ''} onChange={(e) => update('status', e.target.value)}>
        <option value="">Semua Status</option>
        <option value="ACTIVE">ACTIVE</option>
        <option value="SUSPENDED">SUSPENDED</option>
        <option value="TRIAL">TRIAL</option>
      </select>

      <button
        type="button"
        className="rounded-md border border-slate-700 bg-slate-950 px-3 py-1.5 text-xs text-slate-200"
        onClick={() => setFilters({ search: '', plan: '', status: '' })}
      >
        Reset
      </button>
    </div>
  );
};

export default TenantFilterBar;
